export const PATHS = {
    IMAGES: '/images/'
} as const;

export const getImagePath = (filename: string) => `${PATHS.IMAGES + filename}`;
